export default {
  leastDrawn: 'ең аз түскендер',
  mostDrawn: 'ең көп түскендер',
  leastPlayed: 'Ең аз ойналған',
  mostPlayed: 'Ең көп ойналған',
  drawFrom: 'Таралым ауқыты',
  h: 'сағ', // сағаттың қысқартылған түрі
  startingIn: 'Басталады',
  waitingForDrawnFrom: 'Таралымды күту',
  displayingDrawFrom: 'Таралымды көрсету',
  lotteryDraw: 'Лотерея таралымы',
  eventId: 'Оқиға ID',
  bettingShortcuts: 'бәс қысқартулары',
  draw: 'Шығару',
  next5Events: 'Келесі {value} көрсетілуде',
  events: 'Оқиғалар',
  schedule: 'Кесте',
  next: 'Келесі',
  event: 'Оқиға',
  later: 'Кейін',
  statistics: 'Статистика',
  lastnRounds: 'Соңғы {value} айналым',
  bettingOffer: 'бәс ұсынысы',
  notDisplayed: 'Көрсетілмеді',
  latestResults: 'Соңғы нәтижелер',
  drawnAt: '{value} шығарылды',
  additionalBetting: 'қосымша бәстер',
  drawSumEvenOdd: 'Таралым саны жұп немесе тақ',
  drawSumTotal: 'Жалпы таралым',
  drawSumRange: 'таралым сомасының ауқымы',
  waitingForDrawNo: 'Таралымды күту №{value}',
  nextDraw: 'келесі таралым',
  waitingForDraw: 'Таралымды күту',
  drawCompleted: 'таралым аяқталды',
  drawDisplayTemporarilyNotAvailable: 'Таралым уақытша қолжетімсіз',
  connectionError: 'Байланыс қатесі!',
  reconnecting: 'Қайта қосылуда...',
  number: 'Сан',
  headerNumberDescriptionUp: 'Оқиға',
  headerNumberDescriptionDown: 'Сан',
};
